module.exports = __webpack_public_path__ + "static/img/top_back.84d16d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/top_back.png
// module id = lpwu
// module chunks = 6